<button
  *transloco="let t"
  (click)="onCardClick()"
  [disabled]="preselected || disabled"
  [class]="getCardClasses()"
  class="flex w-full cursor-pointer items-center justify-between rounded-lg p-4 transition-all duration-200 disabled:cursor-default"
>
  <div class="flex items-center gap-3">
    <div
      [class]="getIconClasses()"
      class="flex size-6 items-center justify-center rounded-full transition-colors duration-200"
    >
      @if (preselected || selected) {
        <span class="material-icons-outlined text-sm"> check </span>
      }
      @if (!preselected && !selected) {
        <span class="material-icons-outlined"> add </span>
      }
    </div>

    <span class="text-base font-medium">
      {{ t('portal.topicAreas.' + title) }}
    </span>
  </div>

  @if (trialing) {
    <div
      class="align-right rounded-2xl bg-blue p-1 px-3 text-center text-xs font-medium text-white"
      style="text-box: trim-both cap alphabetic"
    >
      {{ 'product.dialog.trialingBadge' | transloco }}
    </div>
  }
</button>
